<template>
  <div class="page-service" :class="{'mobile': _isMobile}">
    <div class="service-wrap " :class="{'pc': !_isMobile}">
      <cmpBanner bannerType="6"></cmpBanner>

      <div class="g-wrap">
        <cmpTab :tabs="tabList" :activeVal="activeVal" :subHeight="'760px'" @eventTabClick="eventTabClick"></cmpTab>

        <div class="con person-list-con" v-if="activeVal==='1'">
          <el-row class="person-list" :gutter="_isMobile?20:100">
            <el-col class="item" :span="_isMobile?12:8" v-for="(item, i) in data1" :key="i">
              <div class="pic-box">
                <img v-lazy="item.picture" alt="">
              </div>
              <div class="info">
                <p class="m-font-2">{{item.name}}</p>
              </div>
            </el-col>
          </el-row>

          <!-- 无数据 -->
          <div class="g-no-data" v-if="data1.length === 0 && !listLoading">
            <div class="no-data-bg"></div>
            <p class="txt text-center">暂无数据</p>
          </div>

          <cmpMyPagination :currentPage="listQuery.page" :pageSize="listQuery.size" :total="total" @eventPage="eventPage"></cmpMyPagination>
        </div>

        <div class="con form-box" v-else>
          <div class="left">
            <el-form class="form" ref="form1" :model="form1" :rules="rules1" label-width="120px" label-position="top" v-if="activeVal==='2'">
              <template>
                <el-form-item label="物品名称" prop="name">
                  <el-input v-model="form1.name"></el-input>
                </el-form-item>
  
                <el-form-item label="物品描述" prop="content">
                  <el-input type="textarea" autosize :autosize="{ minRows: 3}" v-model="form1.content" :maxlength="500"></el-input>
                </el-form-item>
  
                <el-form-item label="丢失地址" prop="address">
                  <el-input v-model="form1.address"></el-input>
                </el-form-item>

                <!-- <el-form-item label="丢失时间" prop="lostTime">
                  <el-input v-model="form1.lostTime"></el-input>
                </el-form-item> -->
  
                <el-form-item label="联系人" prop="owner">
                  <el-input v-model="form1.owner"></el-input>
                </el-form-item>
  
                <el-form-item label="联系方式" prop="telephone">
                  <el-input v-model="form1.telephone"></el-input>
                </el-form-item>
              </template>

              
            </el-form>

            <el-form class="form" ref="form2" :model="form2" :rules="rules2" label-width="120px" label-position="top" v-if="activeVal==='3'">
              <template>
                <el-form-item label="留言类型" class="area" prop="type">
                  <el-select v-model="form2.type" placeholder="请选择" style="width:100%;">
                    <el-option
                      v-for="item in typeList"
                      :key="item.code"
                      :label="item.value"
                      :value="item.code">
                    </el-option>
                  </el-select> 
                </el-form-item>
  
                <el-form-item label="联系人" prop="name">
                  <el-input v-model="form2.name"></el-input>
                </el-form-item>
  
                <el-form-item label="联系方式" prop="telephone">
                  <el-input v-model="form2.telephone"></el-input>
                </el-form-item>
  
  
                <el-form-item label="留言内容" prop="content">
                  <el-input type="textarea" autosize :autosize="{ minRows: 3}" v-model="form2.content" :maxlength="500"></el-input>
                </el-form-item>
              </template>
            </el-form>

            <div class="footer">
              <el-button class="btn-save" type="primary" @click="save">提交</el-button>
              <!-- <el-button @click="cancel">取 消</el-button> -->
            </div>
          </div>

          <div class="right">
            <!-- <h2 class="m-font-3 mb-20" style="font-weight: bold;" v-if="activeVal==='2'">关于物品遗失</h2> -->
            <h2 class="m-font-3 mb-20" v-if="activeVal==='2'">关于物品遗失</h2>

            <div v-if="activeVal==='2'">
              <cmpDetail :detailData="data2" :hideName="true"></cmpDetail>
            </div>
            <!-- <div class="g-detail-html trans" v-if="activeVal==='2'">
              <p>1.为加强对遗失物品及失物招领的管理，维护失主的权益，进一步弘扬拾金不昧的精神，营造温馨和谐的校园环境,特制定本管理规定。 一、基本管理制度 1、失物招领地点:行政楼101室保卫处; 2、失物招领时间:星期一至星期五8:30~~ 16:00 (寒暑假及国定假日除外) ; 3、工作要求:工作人员必须如实做好登记工作，如有人员.上交拾到物品应及时做好登记、保存;如 有人认领物品，必须谨慎仔细核查，以防冒领、错领和重领的情况。 二、储存管理制度 1、物品储存前要仔细检查是否完好无损，并认真做好遗失物品接收记录，存放到专用失物存放柜; 2、接收遗失物品时一旦发现物品存在损坏、残缺等问题，即刻做好接收物品情况登记; 3、接收物品完好，后期如有人为毁坏，接收部门]承担责任; 4、所有接收遗失物品，接收部门J一律不得私自带回使用; 5、对于出现冒领、挪用、私吞等情况，上报相关部门 或二级学院进行处分，情节严重者还应承担相 应的法律责任。 三、失物招领流程 1、失物接收 (1)拾到失物的人员将遗失物品交至学校保卫处，由保卫处人员接收并当场核查物品情况，做好接 收情况记录; (2)如遇到遗失物品内有明确提示失主身份的，应及时主动与失主取得联系; (3)遗失物品及时上传保卫处网页失物招领专栏，以便失主可及时查询信息; (4)保管部门]应注意失物的安全存放，储存柜子应及时锁好。 2、失物认领 (1)在确认失物是否属于认领人时，工作人员应注意态度及用语，谨慎仔细，细心但不苛刻，确保 物归原主; (2)认领人前来认领物品时，需出示有效证件，待工作人员确认无误后，给予办理认领手续并签字 确认，将遗失物品归还失主。 四、其他 本管理规定自公布之日起施行，由保卫处负责解释。</p>
            </div> -->

            <div class="msg-list" v-if="activeVal==='3'">
              <h2 class="m-font-3">留言选登</h2>

              <div class="list">
                <div class="item m-font-6" v-for="(item, i) in dataList" :key="i">
                  <div class="txt ques mb-10">
                    <img src="~@images/icon_liuyan.png" alt="">
                    <p>{{item.content}}</p>
                  </div>
                  <div class="txt answer">
                    <img src="~@images/icon_replay.png" alt="">
                    <p>{{item.reply}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@assets/css-mobile/service/index.scss'
import { validate } from '@/utils/util'
export default {
  watch: {
    $route() {
      this.activeVal = this.$route.query.pageType || '1'
      
      this.listQuery.page = 1
      this.getData()
    }
  },
  data() {
    let validatePhoneNo = (rule, value, callback) => {
      if (!validate(value, 'phone')) {
        callback(new Error('手机号不存在'))
      } else {
        callback()
      }
    }
    return {
      activeVal: this.$route.query.pageType || '1',
      tabList: [
        {
          name: '志愿者',
          val: '1'
        },
        {
          name: '失物登记',
          val: '2'
        },
        {
          name: '观众留言',
          val: '3'
        }
      ],
      value1: '',
      form1: {
        name: '',
        content: '',
        address: '',
        lostTime: '12:00',
        owner: '',
        telephone: ''
      },
      rules1: {
        name: [
          { required: true, message: '请输入物品名称', trigger: 'blur' },
        ],
        owner: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
        ],
        telephone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhoneNo, trigger: 'blur' }
        ],
      },
      form2: {
        type: '',
        name: '',
        telephone: '',
        content: ''
      },
      rules2: {
        type: [
          { required: true, message: '请选择留言类型', trigger: 'change' },
        ],
        name: [
          { required: true, message: '请输入物品名称', trigger: 'blur' },
        ],
        telephone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhoneNo, trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入留言内容', trigger: 'blur' },
        ],
      },
      typeList: [],
      dataList: [],
      listQuery: {
        page: 1,
        size: 9,
      },
      total: '0',
      listLoading: false,
      data1: [],
      data2: {},
      // data3: {},
    }
  },
  methods: {
    getData() {
      switch(this.activeVal) {
        case '1':
          this.getData1()
          break
        case '2':
          this.getData2()
          break
        case '3':
          this.getData3()
          break
        case '4':
          this.getData4()
          break
        case '5':
          this.getData5()
          break
      }
    },
    // 志愿者
    getData1() {
      this.listLoading = true
      this.$http
        .get('/webapi/serve/volunteer', {
          ...this.listQuery
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            let data = res.data
            this.data1 = data.records
            this.total = data.total
          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
        })
    },
    // 失物登记
    getData2() {
      this.$nextTick(() => {
        this.$refs['form1'].clearValidate()
      })
      
      this.$http
        .get('/webapi/serve/lostRules', {})
        .then(res => {
          if (res.success) {
            this.data2 = res.data
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 观众留言
    getData3() {
      this.$nextTick(() => {
        this.$refs['form2'].clearValidate()
      })
      this.listLoading = true
      this.$http
        .get('/webapi/serve/audienceMessage/list', {
          ...this.listQuery,
          size: 20
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            let data = res.data
            this.dataList = data.records
            this.total = data.total
          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
        })
    },
    getDict() {
      this.$http
        .get('/webapi/collection/dict', {})
        .then(res => {
          if (res.success) {
            this.typeList = res.data.messageType
          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
        })
    },
    // 保存
    save() {
      if(this.activeVal === '3') {
        this.save2()
        return
      }
      this.$refs['form1'].validate((valid) => {
        if (valid) {
          this.$http.post('/webapi/serve/lostRegistration', {
            ...this.form1,
          }).then((res) => {
            if(res.success) {
              this.$message.success('保存成功')
              this.$refs['form1'].resetFields()
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          return false
        }
      })
    },
    save2() {
      this.$refs['form2'].validate((valid) => {
        if (valid) {
          this.$http.post('/webapi/serve/audienceMessage/add', {
            ...this.form2,
          }).then((res) => {
            if(res.success) {
              this.$message.success('保存成功')
              this.$refs['form2'].resetFields()
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          return false
        }
      })
    },
    eventTabClick(val) {
      this.activeVal = val
      this.listQuery.page = 1
      this.getData()
    },
    goDetail(item) {
      this.$router.push({
        path: '/creative/detail',
        query: {id: item.id}
      })
    },
    eventPage(obj) {
      this.listQuery.page = obj.page
      this.listQuery.size = obj.size
      this.getData1()
    },
  },
  created() {
    this.getDict()
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.service-wrap {
  color: #3D3D3D;
  .con {
    padding: 30px 0;
  }

  .person-list {
    .item {
      display: flex;
      margin-bottom: 70px;
      .pic-box {
        position: relative;
        img {
          position: relative;
          width: 200px;
          height: 260px;
          border-radius: 8px;
          object-fit: cover;
          z-index: 3;
        }
        &:before {
          position: absolute;
          bottom: -30px;
          left: -30px;
          content: '';
          display: block;
          width: 400px;
          height: 200px;
          border-radius: 8px;
          background: linear-gradient(117deg, #EDEDE0 0%, #FAFAF8 100%);
        }
      }
      .info {
        position: relative;
        display: flex;
        align-items: flex-end;
        z-index: 3;
        padding-bottom: 60px;
        padding-left: 20px;
      }

      &:nth-child(8n+1) {
        .pic-box {
          &:before {
            background: linear-gradient(117deg, #EDEDE0 0%, #FAFAF8 100%);
          }
        }
      }
      &:nth-child(8n+2) {
        .pic-box {
          &:before {
            background: linear-gradient(117deg, #DCD1D4 0%, #DED0D4 0%, #F9F9F9 98%, #F4F1F3 100%);
          }
        }
      }
      &:nth-child(8n+3) {
        .pic-box {
          &:before {
            background: linear-gradient(117deg, #E4E3E3 0%, #FDFDFD 100%);
          }
        }
      }
      &:nth-child(8n+4) {
        .pic-box {
          &:before {
            background: linear-gradient(117deg, #D6E4EB 0%, #F8F9FB 100%);
          }
        }
      }
      &:nth-child(8n+5) {
        .pic-box {
          &:before {
            background: linear-gradient(117deg, #D3DFDC 0%, #FEFFFF 100%);
          }
        }
      }
      &:nth-child(8n+6) {
        .pic-box {
          &:before {
            background: linear-gradient(117deg, #F3E7DE 0%, #FBF9FA 100%);
          }
        }
      }
      &:nth-child(8n+7) {
        .pic-box {
          &:before {
            background: linear-gradient(117deg, #EDEDE0 0%, #FAFAF8 100%);
          }
        }
      }
      &:nth-child(8n+8) {
        .pic-box {
          &:before {
            background: linear-gradient(117deg, #DCD1D4 0%, #DED0D4 0%, #F9F9F9 98%, #F4F1F3 100%);
          }
        }
      }
    }
  }

  .msg-list {
    h2 {
      font-weight: bold;
    }
    .item {
      padding: 20px 0;
      border-bottom: 1px dashed rgba(61, 61, 61, 0.3);
      .txt {
        display: flex;
        align-items: flex-start;
        line-height: 26px;
        img {
          margin-right: 13px;
          padding-top: 3px;
          width: 20px;
          height: auto;
        }
      }
    }
  }

  .form-box {
    display: flex;
    .left {
      width: 500px;
      margin-right: 50px;

      .footer {
        margin-top: 40px;
        .btn-save {
          width: 240px;
        }
      }
    }
    .right {
      padding: 20px 16px;
      box-sizing: border-box;
      flex: 1;
      background: rgba(255, 255, 255, 0.5);
      h2 {
        font-weight: bold;
      }
    }
    /deep/ .form {
      .el-form-item__label {
        font-size: 20px;
        color: #3D3D3D;
      }
    }
  }
}
</style>


